import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getEgresosUnidad.php';

export default function getEgresosUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}